$('.site-footer__box-logo').on("webkitAnimationEnd mozAnimationEnd animationend", function(){
    $(this).attr('data-state', 'idle');
});

$('.site-footer__box').hover(function(){
    let $logo = $(this).find('.site-footer__box-logo');

    if ($logo.length > 0) {
        $logo.attr('data-state', 'animating');
    }
});
